/**
 * jmx 全局事件key定义
 */

enum GlobalEventKey {
    /**
     * 新页面的方式打开erp页面（会处理好联登）
     */
    COMMON_GYL_OPENERPPAGE = 'common.gyl.openErpPage'
}

export default GlobalEventKey
